import React from "react";
import { connect } from "react-redux";
import { Box, Typography, LinearProgress, Container, withStyles } from "@material-ui/core";
import { AVATAR_CREATION_DELAY } from "../../../config";

const styles = {
  progressBar: {
    transition: 'transform 1s linear',
  },
};

class AvatarWaitTimer extends React.Component {
  state = {
    countdown: 0,
  };
  timeoutId = 0;

  setTimeoutId(newTimeoutId) {
    clearTimeout(this.timeoutId);
    this.timeoutId = newTimeoutId;
  }

  startTimer() {
    const avatarReadyAt = this.props.avatarReadyAt;
    const setCountdownMs = timeMs => this.setState({countdown: Math.ceil(timeMs / 1000)});
    if (avatarReadyAt) {
      const now = new Date();
      const waitMs = avatarReadyAt.getTime() - now.getTime();
      setCountdownMs(waitMs);
      if (waitMs > 0) {
        const updateCountdown = () => {
          const now = new Date();
          const waitMs = avatarReadyAt.getTime() - now.getTime();
          setCountdownMs(waitMs);
          if (waitMs >= 1000) {
            this.setTimeoutId(setTimeout(updateCountdown, waitMs % 1000 + 1));
          } else {
            this.setTimeoutId(setTimeout(() => setCountdownMs(0), Math.max(waitMs, 0)));
          }
        }
        this.setTimeoutId(setTimeout(updateCountdown, waitMs % 1000 + 1));
        return;
      }
    } else {
      setCountdownMs(0);
    }
    this.setTimeoutId(0);
  }

  componentDidMount() {
    this.startTimer();
  }

  componentDidUpdate(prevProps) {
    if (this.props.avatarReadyAt !== prevProps.avatarReadyAt) {
      this.startTimer();
    }
  }

  componentWillUnmount() {
    this.setTimeoutId(0);
  }

  render() {
    const classes = this.props.classes;

    const countdown = this.state.countdown;

    let message = "Your Mindfile Avatar is initializing.";
    let progressBar = null;

    if (countdown > 0) {
      let minutes = Math.floor(countdown / 60);
      let seconds = countdown % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      message = `${message} It will be ready in ${minutes}:${seconds}.`;

      let progressFraction = Math.min(1, (AVATAR_CREATION_DELAY - countdown + 1) / AVATAR_CREATION_DELAY);
      progressBar = (
        <Box mt={1}>
          <LinearProgress
            classes={{bar1Determinate: classes.progressBar}}
            variant="determinate"
            value={progressFraction * 100}
          />
        </Box>
      );
    }

    return (
      <Container style={{marginTop: "2rem"}}>
        <Typography variant="h6">{message}</Typography>
        {progressBar}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    avatarReadyAt: state.avatarReadyAt,
  };
}

export default connect(mapStateToProps)(withStyles(styles)(AvatarWaitTimer));